// 路由信息，纯JS对象，方便读取路由信息
import HomeV2 from './views/home.vue';

const routes = [
  {
    path: '/homev2',
    name: 'homev2',
    component: HomeV2,
    desc: '首页V2版',
  },
  {
    beforeEnter: async (to, from, next) => {
      next({
        path: '/homev2',
        replace: true,
      });
    },
    path: '/',
  },
  {
    path: '/record',
    name: 'record',
    component: () => import('./views/e-stamp-record/index.vue'),
    desc: '印花记录',
  },
];
export default {
  routes,
};
